// Represents a flattened list of category and subcategory.
export interface FlatGroupOptionType {
    // key of the group an option belongs to OR null
    groupKey: string | null;
    // compound key of the option and group or key of the group
    value: string;
    // label of the thing to display
    label: string;
    // keys of the options under the group
    optionKeys: string[];
}

/**
 * Take a key from category/item id and turn it into a key that is unique in the list
 * (since it is possible that an item is in more than one category)
 */
export const flatGroupMakeCompoundKey = (groupKey: number, optionKey: number) =>
    `${groupKey}.${optionKey}`;

// return the original option key from a compound key, empty if no option key
export const flatGroupGetOptionPickedFromCompoundKey = (option: string) =>
    option?.split ? option.split('.')?.[1] : '';

// return the group key from a compound key, empty string otherwise.
export const flatGroupGetGroupKeyFromCompoundKey = (option: string) =>
    option?.split ? option.split('.')?.[0] : '';

// determines if this flat item is a group or category
export const flatGroupGetIsGroup = (option?: FlatGroupOptionType) => option?.groupKey === null;
